export default "__VITE_ASSET__a74815b0__"